import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";

const FlagID = ({ className }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="8" fill="#E70011" />
    <rect y="8" width="24" height="8" fill="#FFFFFF" />
    <rect width="24" height="16" fill="none" stroke="rgba(0,0,0,0.12)" strokeWidth="0.5" />
  </svg>
);

const FlagUS = ({ className }) => (
  <svg viewBox="0 0 24 16" className={className} aria-hidden="true">
    <rect width="24" height="16" fill="#B22234" />
    <rect y="1.23" width="24" height="1.23" fill="#FFFFFF" />
    <rect y="3.69" width="24" height="1.23" fill="#FFFFFF" />
    <rect y="6.15" width="24" height="1.23" fill="#FFFFFF" />
    <rect y="8.62" width="24" height="1.23" fill="#FFFFFF" />
    <rect y="11.08" width="24" height="1.23" fill="#FFFFFF" />
    <rect y="13.54" width="24" height="1.23" fill="#FFFFFF" />
    <rect width="10" height="8.6" fill="#3C3B6E" />
  </svg>
);

/**
 * light — teks putih di atas hero gelap
 * dark — di navbar putih / menu mobile
 */
const LanguageSwitcher = ({ light = false, className = "" }) => {
  const { lang, setLang } = useLanguage();

  const btn = (code, Flag, label) => {
    const active = lang === code;
    return (
      <button
        type="button"
        onClick={() => setLang(code)}
        aria-label={label}
        title={label}
        data-testid={`lang-${code}`}
        className={`inline-flex items-center gap-1.5 px-2 py-1.5 rounded-full text-xs font-semibold transition ${
          active
            ? light
              ? "bg-white/20 text-white ring-1 ring-white/40"
              : "bg-[rgba(232,32,32,0.08)] text-[#e82020] ring-1 ring-[rgba(232,32,32,0.35)]"
            : light
              ? "text-white/80 hover:bg-white/10 hover:text-white"
              : "text-zinc-600 hover:bg-zinc-100"
        }`}
      >
        <Flag className="w-5 h-3.5 rounded-[2px] shadow-sm" />
        <span className="hidden sm:inline uppercase tracking-wide">{code === "id" ? "ID" : "EN"}</span>
      </button>
    );
  };

  return (
    <div className={`inline-flex items-center gap-0.5 p-0.5 rounded-full ${light ? "bg-white/10" : "bg-zinc-100"} ${className}`} role="group" aria-label="Language">
      {btn("id", FlagID, "Bahasa Indonesia")}
      {btn("en", FlagUS, "English (US)")}
    </div>
  );
};

export default LanguageSwitcher;
